/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputPosition
 */
export interface InputPosition {
    /**
     * 
     * @type {string}
     * @memberof InputPosition
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof InputPosition
     */
    divisionId?: number;
    /**
     * 
     * @type {string}
     * @memberof InputPosition
     */
    name: string;
}

/**
 * Check if a given object implements the InputPosition interface.
 */
export function instanceOfInputPosition(value: object): boolean {
    if (!('name' in value)) return false;
    return true;
}

export function InputPositionFromJSON(json: any): InputPosition {
    return InputPositionFromJSONTyped(json, false);
}

export function InputPositionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputPosition {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
        'divisionId': json['divisionId'] == null ? undefined : json['divisionId'],
        'name': json['name'],
    };
}

export function InputPositionToJSON(value?: InputPosition | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'comment': value['comment'],
        'divisionId': value['divisionId'],
        'name': value['name'],
    };
}

